// extracted by mini-css-extract-plugin
export default {"loginDiv":"login_loginDiv__yfjfy","mainBody":"login_mainBody__uMTp9","loginBlock":"login_loginBlock__j+EqR","fadeInUp":"login_fadeInUp__oJzT+","bgLogin":"login_bgLogin__7KGa-"};